<template>
	<div class="item_media item_html">
		<iframe ref="htmlFrame" id="entrance_intro" title="카페 대문 - html" width="100%" height="400" frameborder="0"></iframe>
	</div>
</template>

<script>
	export default {
		inheritAttrs: false,
		props: ['layer', 'baseFontColor'],
		methods: {
			unescapeBracket(str) {
				return str.replace(/&lt;/g, '<').replace(/&gt;/g, '>');
			}
		},
		mounted() {
			// XSS 대응으로 '<', '>' 이 escape 되어있는데 사용자가 입력한 HTML 내용은 escape 되면 안됨.
			// content 에 있는 script 태그는 서버에서 제거되어 내려옴.
			const unescapedContent = this.unescapeBracket(this.layer.content);
			
			let iframeDocument = this.$refs.htmlFrame.contentWindow.document;
			iframeDocument.body.innerHTML = `<div id="EntranceArea">${unescapedContent}</div>`;

			let styleElement = iframeDocument.createElement('style');
			styleElement.innerHTML = 'body,div,dl,dt,dd,ul,ol,li,h1,h2,h3,h4,h5,h6,pre,code,form,fieldset,legend,textarea,p,blockquote,th,td,input,select,textarea,button{margin:0;padding:0}' +
				'fieldset,img{border:0 none;margin:0}' +
				'dl,ul,ol,menu,li{list-style:none}' +
				'blockquote, q{quotes:none}' +
				'blockquote:before, blockquote:after,q:before, q:after{content:\'\';content:none}' +
				'input,select,textarea,button{vertical-align:middle}' +
				'input::-ms-clear{display:none}' +
				'button{border:0 none;background-color:transparent;cursor:pointer}' +
				'body,th,td,input,select,textarea,button{font-size:12px;line-height:1.5;font-family:\'Apple SD Gothic Neo\', \'맑은고딕\', \'Malgun Gothic\', \'돋움\', dotum, sans-serif;color:#333}' +
				'a{text-decoration:none}' +
				'a:active,a:hover{text-decoration:underline}' +
				'a:active{background-color:transparent}' +
				'address,caption,cite,code,dfn,em,var{font-style:normal;font-weight:normal}' +
				'#EntranceArea{overflow-y:hidden;color:' + this.baseFontColor + '}' +
				'#EntranceArea:before,#EntranceArea:after{display:table;clear:both;content:\'\'}';
			iframeDocument.head.appendChild(styleElement);
			
			let fallbackScriptElement = iframeDocument.createElement('script');
			fallbackScriptElement.innerHTML = 'function Resizer(){this.intervalId=null,this.roopCnt=5,this.preh=-1,this.glb=null}Resizer.prototype={init:function(e){this.glb=e,this.resizeFromLocalStorage(),this.resize()},call:function(){this.roopCnt--,this.intervalId=setTimeout(this.glb+".resize()",1e3)},resize:function(){if(document.body){var e=document.getElementById("EntranceArea").offsetHeight;if(this.preh==e||this.roopCnt<0)return void this.execute(e);this.preh=e}this.call()},execute:function(e){clearTimeout(this.intervalId),parent&&parent.document.getElementById("entrance_intro")&&(parent.document.getElementById("entrance_intro").height=e,window.localStorage&&window.localStorage.setItem(this.glb,e),this.resizeForBorder())},resizeForBorder:function(){var e=document.getElementById("tx_background_opacity");if(null!==e){var t=document.getElementById("EntranceArea"),i=2*parseInt(e.style.borderWidth);e.style.height=t.offsetHeight-i+"px",e.style.width=t.offsetWidth-i+"px"}},resizeFromLocalStorage:function(){if(window.localStorage){var e=window.localStorage.getItem(this.glb);e&&this.execute(e)}}};var IFRAME_RESIZE_SHELL=null;function forceResize(){(IFRAME_RESIZE_SHELL=new Resizer).init("IFRAME_RESIZE_SHELL")}(function(){var count = 100; function resizeTick(){if(count > 0){count--;forceResize();setTimeout(resizeTick, 200)}}; setTimeout(resizeTick, 200);})();';
			iframeDocument.body.appendChild(fallbackScriptElement);
		}
	}
</script>
